module.exports = __webpack_public_path__ + "static/media/bread_crum_arrow.363f7d96.svg";